import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import useBreakpoint from 'hooks/useBreakpoint'
import React, { useState } from 'react'
import { translate } from 'utils/propKeysTranslations'

const RoleSelectorButton = ({ options, onChange }) => {
  const [option, setOption] = useState(options[0])
  const bigScreen = useBreakpoint()
  const handleClick = (event, newOption) => {
    if (newOption === null) return
    setOption(newOption)
    onChange(newOption)
  }
  return (
    <ToggleButtonGroup
      value={option}
      exclusive
      onChange={handleClick}
      orientation={bigScreen ? 'horizontal' : 'vertical'}
      className='self-center m-8'
    >
      {options.map((role) => (
        <ToggleButton value={role} key={role.role}>
          {translate(role.role)}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}

export default RoleSelectorButton
